(function(){
  'use strict';
  var CHEIE = 'ck_aparat';                 // acelasi nume ca pe pagina de acasa
  var BRN = {jura:'Jura', philips:'Philips', saeco:'Saeco', gaggia:'Gaggia',
             krups:'Krups', delonghi:'De’Longhi'};
  var D = null, cerut = false;

  function red(s){ return (s||'').toLowerCase().replace(/[^a-z0-9]+/g,''); }
  function get(){ try { return localStorage.getItem(CHEIE) || ''; } catch(e){ return ''; } }
  function set(v){ try { localStorage.setItem(CHEIE, v); } catch(e){} }

  /* Ce fel de produs e. Pe pagina de produs din tema nu se scrie nimic pe
     mana: se da doar `data-ck-handle`, iar steagurile vin din acelasi tabel
     care a facut paginile de ghid. Asa nu exista doua adevaruri. */
  function desprePr(c){
    var h = c.getAttribute('data-ck-handle') || '';
    if (h && D){
      for (var i = 0; i < D.produse.length; i++)
        if (D.produse[i].handle === h) return D.produse[i];
      return null;                       // produs care nu e de intretinere
    }
    return {handle: h,
            branduri:  (c.getAttribute('data-ck-branduri')  || '').split(',').filter(Boolean),
            categorii: (c.getAttribute('data-ck-categorii') || '').split(',').filter(Boolean),
            aquaclean: c.getAttribute('data-ck-aquaclean') === '1',
            piesa_grup: c.getAttribute('data-ck-grup') === '1',
            vaselina:  c.getAttribute('data-ck-vaselina') === '1',
            disponibil: true};
  }

  /* ---- verdictul. Aceleasi reguli ca la generarea paginilor de ghid ---- */
  function verdict(p, nume){
    var m = D.modele[nume];
    if (!m || !p) return null;
    var br  = p.branduri || [];
    var cat = p.categorii || [];
    var aq  = !!p.aquaclean;
    var pg  = !!p.piesa_grup;
    var mb  = BRN[m.b] || m.b;

    /* Stocul NU se raspunde aici. Il spune pagina, la butonul de cos, si il
       stie in timp real. Caseta lucreaza cu un fisier scris la generare: daca
       acela ramane in urma, caseta ar scrie „nu e pe stoc" la un produs care
       e — s-a si intamplat, la 155 de perechi, cu Setul DeLonghi Premium.
       Stocul ramane folosit DOAR la inlocuitor, unde a gresi inseamna cel
       mult sa nu propui ceva, nu sa minti. */
    if (br.length && br.indexOf(m.b) < 0)
      return {ok:0, de:'E făcut pentru ' + br.map(function(b){return BRN[b]||b;}).join(', ') +
                       ' — nu pentru ' + mb + '.'};
    if (aq && ['philips','saeco','gaggia'].indexOf(m.b) < 0)
      return {ok:0, de:'Conține filtre AquaClean, care intră doar în Philips, Saeco și Gaggia.'};
    if (pg && !m.grup)
      return {ok:0, de:'Sunt piese pentru grupul de infuzare, iar ' + nume +
                       ' nu are grup care să se scoată.'};
    /* Acelasi lucru pe care il face raftul paginii: la brandurile care nu ung
       grupul, vaselina nu apare. Daca ar aparea aici, caseta ar contrazice
       pagina — exact greseala de pe ECAM22.110.B, din 12 septembrie. */
    if (p.vaselina && !m.unge)
      return {ok:0, de: (m.grup
        ? 'La ' + mb + ' infuzorul nu se unge — manualele nu cer vaselină nicăieri.'
        : nume + ' nu are grup de infuzare care să se ungă.')};
    if ((aq || cat.indexOf('filtru') >= 0) && !m.filtru)
      return {ok:0, de:nume + ' nu are locaș de filtru de apă.'};
    if (cat.indexOf('lapte') >= 0 && cat.length === 1 && !m.lapte)
      return {ok:0, de:nume + ' nu are circuit de lapte.'};
    return {ok:1, de:'L-am verificat în manualul lui.'};
  }

  /* ---- inlocuitorul se cauta in ACEEASI categorie, nu in tot raftul ----
     Se alege dupa CATE categorii are in comun, abia apoi dupa pret. Fara
     asta, un filtru Jura respins la un Philips primea drept inlocuitor un
     decalcifiant ieftin — amandoua au „decalcifiere" in categorii — in loc
     de filtrul CF109, care e chiar produsul cautat. */
  function altceva(eul, nume){
    var cat = (eul.categorii) || [];
    if (!cat.length) return null;
    var bun = null, scorBun = -1;
    for (var i = 0; i < D.produse.length; i++){
      var p = D.produse[i];
      if (p.handle === eul.handle || !p.disponibil) continue;
      var scor = (p.categorii || []).filter(function(x){ return cat.indexOf(x) >= 0; }).length;
      if (!scor) continue;
      var v = verdict(p, nume);
      if (!v || !v.ok) continue;
      if (scor > scorBun ||
          (scor === scorBun && parseFloat(p.pret) < parseFloat(bun.pret))){
        bun = p; scorBun = scor;
      }
    }
    return bun;
  }

  var ICO_DA = '<svg viewBox="0 0 20 20" width="18" height="18" aria-hidden="true">' +
    '<circle cx="10" cy="10" r="9" fill="none" stroke="currentColor" stroke-width="1.7"/>' +
    '<path d="m6 10.3 2.6 2.6L14.2 7" fill="none" stroke="currentColor" stroke-width="2" ' +
    'stroke-linecap="round"/></svg>';
  var ICO_NU = '<svg viewBox="0 0 20 20" width="18" height="18" aria-hidden="true">' +
    '<circle cx="10" cy="10" r="9" fill="none" stroke="currentColor" stroke-width="1.7"/>' +
    '<path d="M7 7l6 6M13 7l-6 6" fill="none" stroke="currentColor" stroke-width="2" ' +
    'stroke-linecap="round"/></svg>';

  function esc(s){ return String(s).replace(/[&<>"]/g, function(x){
    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[x]; }); }

  /* Uită aparatul și întreabă din nou. Un singur loc — îl cheamă și «×» din
     colț, și rândul «Schimbă aparatul» din subsol, pe toate casetele din
     pagină deodată (pe lista de produse sunt multe). */
  function uita(){
    set('');
    [].forEach.call(document.querySelectorAll('.ckc'), function(c){
      c.classList.remove('ckc-da', 'ckc-nu');
      var ask = c.querySelector('.ckc-ask'), ans = c.querySelector('.ckc-ans');
      if (!ask || !ans) return;
      ans.hidden = true; ans.innerHTML = '';
      // pe pagina de ghid modelul e al paginii: nu avem ce intreba
      if (c.getAttribute('data-ck-loc') === 'ghid'){ c.style.display = 'none'; return; }
      ask.hidden = false;
      var q = c.querySelector('.ckc-q'); if (q) q.value = '';
    });
    var q1 = document.querySelector('.ckc:not([data-ck-loc]) .ckc-q');
    if (q1){ try { q1.focus(); } catch(e){} }
  }

  function scrie(c){
    var loc = c.getAttribute('data-ck-loc');
    var ask = c.querySelector('.ckc-ask'), ans = c.querySelector('.ckc-ans');

    /* Pagina de ghid: modelul vine din pagina, nu de la om. Nu intrebam ce
       stim deja. Scriem si in memorie, ca pagina de produs sa raspunda
       instant — ăsta e, de fapt, tot rostul casetei de pe ghid. */
    if (loc === 'ghid'){
      var mod = c.getAttribute('data-ck-model') || '';
      if (!mod){ c.style.display = 'none'; return; }
      if (get() !== mod) set(mod);
      /* pagina poate acoperi 2–3 modele; le numim pe toate, dar retinem unul
         — au aceleasi raspunsuri, fiindca impart manualul */
      var arata = c.getAttribute('data-ck-arata') || mod;
      ans.innerHTML = '<p class="ckc-v">' + ICO_DA + '<span>Ți-am reținut ' +
        esc(arata) + '</span></p><p class="ckc-ft">De acum, pe orice produs de pe '
        + 'site îți spunem dacă i se potrivește.<a href="/collections/all">'
        + 'Vezi produsele →</a></p>';
      ask.hidden = true; ans.hidden = false;
      return;
    }

    /* Produsul care nu e de intretinere — cafea, de pilda — n-are ce raspunde.
       Atunci caseta dispare si ramane randul simplu catre ghiduri. */
    var pr = D ? desprePr(c) : null;
    if (!D) return;                       // inca nu stim nimic — nu miscam nimic
    if (c.getAttribute('data-ck-handle') && !pr) return;   // nu e de intretinere
    if (c.getAttribute('data-ck-auto') === '1'){
      c.querySelector('.ckc-in').hidden = false;
      var fb = c.querySelector('.ckc-fb'); if (fb) fb.hidden = true;
    }

    var nume = get();
    if (!nume){ ask.hidden = false; ans.hidden = true; return; }
    if (!D){ ask.hidden = false; ans.hidden = true; return; }
    var m = D.modele[nume], v = m && verdict(pr, nume);
    if (!v){ ask.hidden = false; ans.hidden = true; return; }

    var h = '<p class="ckc-v">' + (v.ok ? ICO_DA : ICO_NU) + '<span>' +
            (v.ok ? 'Da, se potrivește la ' : 'Nu se potrivește la ') + esc(nume) +
            '</span></p><p class="ckc-de">' + esc(v.de) + '</p>';
    if (!v.ok){
      var alt = altceva(pr, nume);
      if (alt) h += '<div class="ckc-alt"><p class="ckc-alt-t">Pentru ' + esc(nume) +
        ' ia:</p><a href="/products/' + esc(alt.handle) + '">' + esc(alt.titlu) +
        '</a><p class="ckc-alt-p">' + esc(alt.pret) + ' lei</p></div>';
    }
    h += '<p class="ckc-ft"><b>' + esc(nume) + '</b>' +
         (m.pagina ? '<a href="' + esc(m.pagina) + '">Ghidul lui →</a>' : '') +
         '<button type="button" class="ckc-alt-btn">Schimbă aparatul</button></p>';
    ans.innerHTML = h;
    c.classList.toggle('ckc-da', !!v.ok);
    c.classList.toggle('ckc-nu', !v.ok);
    ask.hidden = true; ans.hidden = false;
  }

  function toate(){ [].forEach.call(document.querySelectorAll('.ckc'), scrie); }

  function aduc(c){
    if (cerut) return; cerut = true;
    var u = c.getAttribute('data-ck-src');
    fetch(u).then(function(r){ return r.json(); }).then(function(j){
      D = j;
      // cheile reduse, ca „ecam22110b" sa gaseasca „ECAM22.110.B"
      D.chei = Object.keys(D.modele).map(function(k){ return [red(k), k]; });
      [].forEach.call(document.querySelectorAll('.ckc-wait'), function(x){ x.remove(); });
      toate();
    }).catch(function(){
      [].forEach.call(document.querySelectorAll('.ckc-wait'), function(x){
        x.textContent = 'Lista nu s-a încărcat. Caută aparatul în ghidurile noastre.'; });
    });
  }

  function sugestii(c){
    var q = c.querySelector('.ckc-q'), ul = c.querySelector('.ckc-sug');
    var t = q.value.trim();
    if (t.length < 2){ ul.hidden = true; ul.innerHTML = ''; return; }
    if (!D){
      if (!c.querySelector('.ckc-wait')){
        var p = document.createElement('p'); p.className = 'ckc-wait';
        p.textContent = 'Se încarcă lista de modele…'; q.parentNode.appendChild(p);
      }
      return;                        // se reface singur din aduc() → toate()
    }
    var r = red(t), gasit = [];
    for (var i = 0; i < D.chei.length && gasit.length < 40; i++)
      if (D.chei[i][0].indexOf(r) >= 0) gasit.push(D.chei[i][1]);
    gasit.sort(function(a, b){ return a.length - b.length; });
    if (!gasit.length){
      ul.innerHTML = '<li><button type="button" disabled>Nu găsim modelul. ' +
        'Caută-l în <a href="/pages/ghiduri-curatare">ghiduri</a>.</button></li>';
      ul.hidden = false; return;
    }
    ul.innerHTML = gasit.slice(0, 8).map(function(k){
      var m = D.modele[k];
      return '<li><button type="button" data-k="' + esc(k) + '"><b>' + esc(k) +
             '</b>' + (m.ser ? ' <i>· ' + esc(m.ser) + '</i>' : '') + '</button></li>';
    }).join('');
    ul.hidden = false;
  }

  function leg(c){
    /* «×» și «Schimbă aparatul» se prind pe container, o singură dată.
       Răspunsul se rescrie la fiecare alegere, deci un ascultător pus pe
       butonul din el ar trebui legat din nou de fiecare dată — și la prima
       scăpare butonul ar tăcea fără nicio eroare. */
    c.addEventListener('click', function(e){
      if (e.target.closest('.ckc-x, .ckc-alt-btn')){ e.preventDefault(); uita(); }
    });
    var q = c.querySelector('.ckc-q'), ul = c.querySelector('.ckc-sug');
    if (!q) return;
    ['focus','pointerdown'].forEach(function(e){ q.addEventListener(e, function(){ aduc(c); }); });
    q.addEventListener('input', function(){ sugestii(c); });
    q.addEventListener('keydown', function(e){
      var b = [].slice.call(ul.querySelectorAll('button:not([disabled])'));
      if (!b.length) return;
      var i = b.findIndex(function(x){ return x.classList.contains('on'); });
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp'){
        e.preventDefault();
        if (i >= 0) b[i].classList.remove('on');
        i = e.key === 'ArrowDown' ? (i + 1) % b.length : (i <= 0 ? b.length - 1 : i - 1);
        b[i].classList.add('on'); b[i].scrollIntoView({block:'nearest'});
      } else if (e.key === 'Enter'){
        e.preventDefault(); (i >= 0 ? b[i] : b[0]).click();
      } else if (e.key === 'Escape'){ ul.hidden = true; }
    });
    ul.addEventListener('click', function(e){
      var b = e.target.closest('button[data-k]'); if (!b) return;
      set(b.getAttribute('data-k')); ul.hidden = true; ul.innerHTML = ''; toate();
    });
  }

  function porneste(){
    var c = document.querySelectorAll('.ckc');
    if (!c.length) return;
    [].forEach.call(c, function(x){
      // Caseta de pe pagina de produs asteapta tabelul inainte sa se arate:
      // pana atunci ramane randul simplu catre ghiduri, iar daca produsul nu
      // e de intretinere el ramane acolo pentru totdeauna. Zero palpait.
      if (x.getAttribute('data-ck-auto') !== '1'){
        x.querySelector('.ckc-in').hidden = false;
        var fb = x.querySelector('.ckc-fb'); if (fb) fb.hidden = true;
      }
      leg(x);
    });
    // Pe pagina de ghid nu se incarca NIMIC: modelul e scris chiar in pagina.
    var doarGhid = [].every.call(c, function(x){
      return x.getAttribute('data-ck-loc') === 'ghid'; });
    // Pe pagina de produs tabelul se ia de la inceput (15,8 KB comprimat):
    // caseta trebuie sa stie daca produsul asta e de intretinere, altfel ar
    // intreba „se potriveste aparatului tau?" la o pungă de cafea.
    var acum = [].some.call(c, function(x){
      return x.getAttribute('data-ck-auto') === '1'; });
    if (doarGhid) toate();
    else if (acum || get()) aduc(c[0]);
    else toate();
  }

  if (document.readyState === 'loading')
    document.addEventListener('DOMContentLoaded', porneste);
  else porneste();
})();
